import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class BSharedServiceService {

  constructor() { }
  private specificationSubject = new Subject<any>();
  public specification$ = this.specificationSubject.asObservable();
  private sizeSubject = new Subject<any>();
  public size$ = this.sizeSubject.asObservable();
  private productSpecificationSubject = new Subject<any>();
  public productSpecification$ = this.productSpecificationSubject.asObservable();
  private kitSubject = new Subject<any>();
  public kit$ = this.kitSubject.asObservable();
  private cadSubject = new Subject<any>();
  public cad$ = this.cadSubject.asObservable();
  setSpecification(data: any): void {
    this.specificationSubject.next(data); // Emit new data to subscribers
  }
  setProductSpecification(data: any): void {
    this.productSpecificationSubject.next(data); // Emit new data to subscribers
  }
  setKits(data: any): void {
    this.kitSubject.next(data); // Emit new data to subscribers
  }
  setSize(data:any):void{
    this.sizeSubject.next(data);
  }
  setCadData(data: any): void {
    this.cadSubject.next(data); // Emit new data to subscribers
  }
  private formDataSubject = new BehaviorSubject<any>({
    selectedInputPower: null,
    selectedUnits: null,
    selectedRatio: null,
    selectedSpeed: null,
    selectedDutyCycle: null,
    selectedServiceFactor: null,
    selectedOutputSpeed: null
  });
  formData$ = this.formDataSubject.asObservable();
  setFormData(data: any): void {
    this.formDataSubject.next(data);
  }

  getFormData() {
    return this.formDataSubject.asObservable();
  }

  private productCodeSubject = new Subject<any>();
  public productCode$ = this.productCodeSubject.asObservable();
setProductCode(data: any): void {
  this.productCodeSubject.next(data); // Emit new data to subscribers
}
}
